import { ShareSteps } from "../enums/shareFlow";
import type { SchoolClassVisibilities } from "../enums/schoolClasses";

// Amplitude property values for the class events. Our enums are SCREAMING_CASE because they mirror
// the backend, but event property values are lower-case snake_case, so map rather than send the raw
// enum. Keeping the mapping here means the wire format changes in one place.

export const toClassVisibilityProp = (visibility: SchoolClassVisibilities): string => visibility.toLowerCase();

// Omitted unless the class list loaded successfully — an empty list is otherwise ambiguous between
// "no classes", "not fetched yet" and "fetch failed", and a fabricated value would poison the
// property. Callers must pass `hasLoadedSchoolClasses && !schoolClassesLoadError`: a failed fetch
// still sets hasLoaded (to stop refetch loops), so that flag alone would report a teacher with
// many classes as their first.
export const toIsFirstClassProps = (
    hasLoadedSchoolClassesSuccessfully: boolean,
    schoolClassCount: number
): { is_first_class?: boolean } =>
    hasLoadedSchoolClassesSuccessfully ? { is_first_class: schoolClassCount === 0 } : {};

export const SHARE_STEP_PROPS: Record<ShareSteps, string> = {
    [ShareSteps.MODE]: "mode",
    [ShareSteps.CLASS]: "class",
    [ShareSteps.TIMING]: "timing",
    [ShareSteps.DETAILS]: "details",
};

export enum ActivityTypeProps {
    TEST = "test",
    VOCAB_TRAINING = "vocab_training",
}
